import { Component, effect, inject, input, signal } from '@angular/core';
import { ClientOrderService, ClientPackageService } from '../services';
import { CartService } from '../services/cart/cart.service';
import { OrderDiscType } from '../dto';
import { PromotionsService } from '../services/promotions/promotions.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalContentComponent } from '../components/modal-content/modal-content.component';
import { TauiBottomSheetModalService } from '@ngx-tailwind-ui/bottom-sheet-modal';

@Component({ template: '' })
export abstract class AbstractBasePanelComponent<T = unknown> {
  private readonly translateService = inject(TranslateService);
  protected readonly modalService = inject(TauiBottomSheetModalService);
  protected readonly promotionService = inject(PromotionsService);
  protected readonly packageService = inject(ClientPackageService);
  protected readonly orderService = inject(ClientOrderService);
  protected readonly cartService = inject(CartService);
  readonly isLoaded = this.packageService.loaded;
  readonly type = this.orderService.type;
  readonly isLoading = this.orderService.loading;
  select = signal<T | null>(null);
  showSelected = signal(true);
  index = input.required<number>();

  protected constructor() {
    effect(() => {
      if (!this.isLoaded() && !this.isLoading()) {
        this.showSelected.set(true);
      }
    });
  }

  setSelected(value: T, type: OrderDiscType) {
    this.select.set(value);

    this.updateOrder<T>(value, type);
  }

  getSelected() {
    return this.select();
  }

  updateOrder<Y>(product: Y | null, disc: OrderDiscType) {
    if (!product) {
      console.group('remove product from order');
    } else {
      console.group('add product to order');
    }

    console.groupEnd();

    this.orderService.updateOrder(product, disc);
    this.cartService.updateCart<Y>(product, disc);
  }

  getDiscountById(id: number) {
    return this.promotionService.getPackageOptionDiscount(id);
  }

  openModal(title: string, description: string): void {
    this.modalService.openBottomSheet({
      contentComponent: ModalContentComponent,
      inputs: {
        title: title,
        description: description,
      },
      showCloseButton: true,
      onClose: () => {
        console.log('Modal closed');
      },
    });
  }

  protected hasTranslationForKey(key: string): boolean {
    const translation = this.translateService.instant(key);
    return translation !== key && translation !== '';
  }
}
